import { render, staticRenderFns } from "./NavBarVerticalDat.vue?vue&type=template&id=3112b016&scoped=true"
import script from "./NavBarVerticalDat.vue?vue&type=script&lang=js"
export * from "./NavBarVerticalDat.vue?vue&type=script&lang=js"
import style0 from "./NavBarVerticalDat.vue?vue&type=style&index=0&id=3112b016&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3112b016",
  null
  
)

export default component.exports